import React, { Component } from 'react'
import { inject, observer, PropTypes as MobxPropTypes } from 'mobx-react';
import { Col, Row } from 'react-bootstrap';
import moment from 'moment'
import CancelModal from './CancelModal';

import { BookingInfo, ButtonVerticalCenter } from './ActiveBookingsStyle'
import { Icon, BorderLine, LogeButtonSlim } from '../GeneralStyle'


import calIcon from '../../images/icons/calendar_lg_gold.png'
import mapIcon from '../../images/icons/map_lg_gold.png'
import persIcon from '../../images/icons/person_double_lg_gold.png'

@inject('bookingStore')

@observer
class ActiveBookingsRow extends Component {

  constructor(props) {
    super(props)
    this.openCancelModal = this.openCancelModal.bind(this)
  }


  openCancelModal() {
    this.cancelmodal.openModal();
  }

  render() {
    const { booking } = this.props

    return (
      <div>
        <Row>
          <BorderLine width={"98%"} />
        </Row>

        <Row>
          <Col xs={12} sm={7} md={10} lg={10}>
            <div>
              <Icon icon={calIcon} />
              <BookingInfo style={{marginLeft: 55}}>{moment(booking.bookingDate).locale("de").format('Do MMMM YYYY')}</BookingInfo>
            </div>
            <div>
              <Icon icon={mapIcon} />
              <BookingInfo style={{marginLeft: 55}}>{booking.golfCourse.courseName}</BookingInfo>
            </div>
            <div >
              <Icon icon={persIcon} />
              <BookingInfo style={{marginLeft: 55}}>{booking.slots === 1 ? booking.slots + " Spielrecht" : booking.slots + " Spielrechte"}</BookingInfo>
            </div>
            {booking.isRemainingStock === true &&
              <div >
                <BookingInfo style={{marginLeft: 55}}>{"Restplatzbuchung"}</BookingInfo>
              </div>}
          </Col>
          <Col xs={12} sm={5} md={2} lg={2}>
            <ButtonVerticalCenter>
              <LogeButtonSlim
                hoverFontColor={"white"}
                onClick={this.openCancelModal}
                style={{ float: "right", margin: 0}}>
                Stornieren</LogeButtonSlim>
            </ButtonVerticalCenter>
          </Col>
        </Row>

        <CancelModal
          onRef={ref => (this.cancelmodal = ref)}
          bookingId={booking.objectId}
          courseName={booking.golfCourse.courseName}
          bookingDate={booking.bookingDate}
        />
      </div>
    )
  }
}

ActiveBookingsRow.propTypes = {
  bookingStore: MobxPropTypes.observableObject
};

export default ActiveBookingsRow;



// WEBPACK FOOTER //
// /src/components/internal/ActiveBookingsRow.js